import React from "react";
import {Link} from 'react-router-dom';
import styled from "@emotion/styled";
import TranslateTransition from "../components/animations/TranslateTransition";
// import PageNotFound from '../assets/images/PageNotFound';


const NotFoundWrapper = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const NotFound404Wrapper = styled.div`
    font-family: Metropolis,serif;
    font-size: 282.5px;
    line-height: 283px;
    /* identical to box height, or 100% */
    
    text-align: center;
    
    /* default/gray/500 */
    
    color: #A0AEC0;
`;

const NotFoundMessage = styled.div`
    /* text-6xl/Medium */
    
    font-family: Metropolis,serif;
    font-size: 64px;
    line-height: 64px;
    /* identical to box height, or 100% */
    text-align: center;
    
    /* default/gray/800 */
    color: #2D3748;
`;

export default function (props) {
    return <NotFoundWrapper>
        {/*<img src={PageNotFound}  />*/}

        <TranslateTransition>
            <NotFound404Wrapper key="Not-Found">
                404
            </NotFound404Wrapper>
            <NotFoundMessage key="Not-Found-Message">
                Page Not Found
            </NotFoundMessage>


        </TranslateTransition>
        <p style={{textAlign: "center"}}>
            <Link to="/">Go to Home </Link>
        </p>


    </NotFoundWrapper>;
}